import React, { useState } from "react";
import LaddaButton, { EXPAND_RIGHT, EXPAND_LEFT } from "react-ladda";

import {
  renderOrderQuantity,
  renderOrderSide,
  renderOrderSymbol,
  renderOrderPrice,
  renderOrderQuantityType,
  renderExecutionsAvg,
} from "./Item";
import { getProductTypeName } from "../../utils/Order/Order";

import style from "./Order.module.scss";
import CircularProgress from "../CircularProgress/CircularProgress";
import { showToast } from "../../utils/Helper";

const InlineDetail = ({ order, hideAvg, getOrderPdf = undefined }) => {
  const [loading, setLoading] = useState(false);

  const downloadPdf = async () => {
    setLoading(() => true);
    try {
      order.OrderCurrencyId = order.OrderSettlementCurrencyId;
      if (!order.CurrentAccount) {
        // Es una orden nueva, rellenar con datos temporales
        order.CurrentAccount = {
          AccountId: 0,
          AccountNumber: "Nueva cuenta",
          Commission: 0,
          AccountName: "Nueva cuenta",
        };
        order.OrderInitDate = new Date();
      }
      const { response } = await getOrderPdf({ order });
      window.open(response.fileUrl);
    } catch (error) {
      showToast("Error downloading order pdf", true);
      console.error(error);
    }

    setTimeout(() => {
      setLoading(() => false);
    }, 3000);
  };

  return (
    <div className={style.detail}>
      <span>{getProductTypeName(order.AssetClassForm)}</span> <span>{renderOrderSide(order)}</span>{" "}
      {renderOrderQuantity(order)} {renderOrderQuantityType(order)} {renderOrderSymbol(order)}
      {" @ "}
      {renderOrderPrice(order)} {!hideAvg && renderExecutionsAvg(order)}
      <div style={{ flex: 1 }} />
      {getOrderPdf && (
        <LaddaButton
          className="btn btn-ladda btn-primary ml-2"
          disabled={loading}
          onClick={downloadPdf}
          data-style={EXPAND_LEFT}
          style={{ padding: "1px 6px" }}
        >
          {loading ? <span>Downloading...</span> : <i className="fa fa-file-pdf-o" />}
        </LaddaButton>
      )}
    </div>
  );
};

export default InlineDetail;
